export default {
  methods: {

    /**
     * Intelligent array to group splitting (based on Laravel collection "split" method).
     *
     * @param list
     * @param numberOfGroups
     * @returns {*|*[]}
     */
    splitArrayToGroups(list, numberOfGroups) {
      if (list.length === 0) return list;
      let groups = [];
      const groupSize = Math.floor(list.length / numberOfGroups);
      const remain = list.length % numberOfGroups;
      let start = 0;
      for (let i = 0; i < numberOfGroups; i++) {
        let size = groupSize;
        if (i < remain) {
          size++;
        }
        if (size) {
          groups.push(list.slice(start, start + size));
          start += size;
        }
      }
      return groups;
    },

    /**
     * Formats a number as USD currency ($0.00)
     *
     * @returns String
     * @param number
     */
    usd(number) {
      return number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    },

    /**
     * Formats a number as percentage (0.00%)
     *
     * @returns String
     * @param number
     */
    pct(number) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 2, // Optional: specify the number of decimal places
        maximumFractionDigits: 2 // Optional: specify the number of decimal places
      });

      return formatter.format(number);
    },

  }
}
